export const TOPIC_FILTER_LABELS = {
  category: "讲什么题材？",
  categoryHint: "不清楚就选「全部」",
  duration: "老师要求讲多久？",
  durationHint: "可以多选",
} as const;
